import {CalendarIcon} from "@components/Icons/CalendarIcon";
import {NavLink, NavLinkProps} from "react-router-dom";
import {ChevronRightIcon} from "@components/Icons/ChevronRightIcon";
import React from "react";
import ResponsivePicture from "@components/ResponsivePicture/ResponsivePicture";
import {useProjectTranslations} from "@i18n/i18nUtils";

export interface BoostCardProps {
    image?: string;
    categoryName: string;
    title: string;
    date: string;
    linkProps: NavLinkProps;
}

const BoostCard = ({image, categoryName, title, date, linkProps}: BoostCardProps) => {

    const {t} = useProjectTranslations();

    const mobileAriaLabel = `${t("cta:boosts:discover")}: ${title}`;

    return (
        <div className="card boost boost-card">

            <NavLink {...linkProps} className="boost-card__overlayLink" aria-label={mobileAriaLabel} />

            <div className="card__hero">
                {!!image &&
                    <ResponsivePicture images={[image]} cover/>
                }
            </div>
            <div className="card__content">
                <div className="card__header">
                    <div className="card__meta">
                        <span className={"tp-xs color-primary"}>{categoryName}</span>
                    </div>
                    <h3 className={"tp-m bold"}>{title}</h3>
                </div>
                <div className="card__actions">
                    <div className="card__date">
                        <span className="card__date__icon"><CalendarIcon/></span>
                        <span className={"card__date__label tp-2xs semibold"}>{date}</span>
                    </div>
                    <NavLink {...linkProps} className={"tp-xs color-primary semibold card__cta"}>
                        <span className={"label"}>{t("cta:boosts:discover")}</span>
                            <span className={"icon"}>
                            <ChevronRightIcon/>
                        </span>
                    </NavLink>
                </div>
            </div>
        </div>
    );

}

export default BoostCard;